import type { TabId } from '../../Tabs';

const DROP_TAB_PREFIX = 'dropTab';

export const getDroppableTabId = (tabId: TabId, sectionId?: string) => `${DROP_TAB_PREFIX}-${tabId}${sectionId ? `-${sectionId}` : ''}`;

export const parseDroppableTabId = (id: string): { tabId: string; sectionId?: string } | null => {
  const prefix = `${DROP_TAB_PREFIX}-`;
  if (!id.startsWith(prefix)) return null;

  const rest = id.slice(prefix.length);
  const separatorIndex = rest.indexOf('-');
  if (separatorIndex === -1) {
    return { tabId: rest };
  }

  return {
    tabId: rest.slice(0, separatorIndex),
    sectionId: rest.slice(separatorIndex + 1),
  };
};
